import { render, staticRenderFns } from "./comDetail.vue?vue&type=template&id=efe039b2&scoped=true&"
import script from "./comDetail.vue?vue&type=script&lang=js&"
export * from "./comDetail.vue?vue&type=script&lang=js&"
import style0 from "./comDetail.vue?vue&type=style&index=0&id=efe039b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe039b2",
  null
  
)

export default component.exports